import React from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'
import Pagination from 'bulma-pagination-react'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'

import PortalListTable from './PortalListTable'
import { fetchPortalWithQuery } from '../../../modules/portal-remote/portalService'
import { requestDeletePortal } from '../mobileHome/MobileHomeContainer'
import withLanguage from '../lang-select/withLanguage'

class PortalListContainer extends React.Component {
  constructor(props) {
    super(props)
    this.handleFetchPortals = _.debounce(this.handleFetchPortals, 200)
  }

  state = {
    pageCount: null,
    portals: null,
  }

  // componentDidMount() {
  //   this.handleFetchPortals(this.props.filter)
  // }

  isNotEqual = (a, b) => !_.isEqual(a, b)

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.filter, prevProps.filter) && this.props.filter) {
      this.handleFetchPortals(this.props.filter)
    }
  }

  handlePortalDelete = async portal => {
    try {
      await requestDeletePortal(portal)
      this.handleFetchPortals(this.props.filter)
    } catch (error) {
      toast.error(error.message)
    }
  }

  handleFetchPortals = async query => {
    try {
      // console.log('query', query)
      const { data, pageCount, limit } = await fetchPortalWithQuery(query)
      // console.log('fetchPortals', portals)
      this.setState({ portals: data, pageCount, limit })
    } catch (error) {
      toast.error(error.message)
    }
  }

  render() {
    const currentPage = _.get(this.props, 'filter.page')

    return (
      <React.Fragment>
        <PortalListTable
          {...this.state}
          currentPage={currentPage}
          language={this.props.language}
          values={this.props.values}
          onPortalDelete={this.handlePortalDelete}
        />
        {this.state.pageCount && (
          <Pagination
            pages={this.state.pageCount}
            currentPage={currentPage}
            onChange={this.props.onPageChange}
          />
        )}
      </React.Fragment>
    )
  }
}

export default compose(
  withLanguage,
  withRouter,
)(PortalListContainer)



// WEBPACK FOOTER //
// ./src/components/templates/portal-list/PortalListContainer.js